var React = require('react');

function CheckMark (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t12.9,3.8 4.5,12.2 3.1,9.4 "}));
}

CheckMark.displayName = "CheckMark";

CheckMark.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = CheckMark;

CheckMark.default = CheckMark;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/checkMark.svg
// module id = ../icon/src/icons/checkMark.svg
// module chunks = 0